import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Home, FileQuestion } from "lucide-react";

const NotFound = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center px-4">
        <div className="mb-8 flex justify-center">
          <div className="w-32 h-32 rounded-full bg-muted flex items-center justify-center">
            <FileQuestion className="w-16 h-16 text-muted-foreground" />
          </div>
        </div>
        <h1 className="text-7xl md:text-9xl font-bold mb-4 bg-gradient-to-r from-primary to-primary/50 bg-clip-text text-transparent">
          404
        </h1>
        <h2 className="text-2xl md:text-3xl font-semibold mb-2">
          {t("notFound.title")}
        </h2>
        <p className="text-lg text-muted-foreground mb-8 max-w-md mx-auto">
          {t("notFound.description")}
        </p>
        <Button asChild size="lg">
          <Link to="/">
            <Home className="w-5 h-5 mr-2" />
            {t("notFound.backHome")}
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
